import { Link, useLocation } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { buttonVariants } from './Button'

/**
 * 403 — rendered INSIDE the shell so the user can navigate away (spec 21 §3.9.4).
 * Never names roles or the roles a page requires (contract defect #11): the reason
 * belongs in the audit log, not on screen.
 */
export function PermissionDenied({ what = 'this page', reason }: { what?: string; reason?: string | null }) {
  const { pathname } = useLocation()
  return (
    <div role="alert" data-state="forbidden" className="mx-auto flex max-w-lg flex-col items-center px-6 py-16 text-center">
      <div className="mb-4 grid size-12 place-items-center rounded-xl bg-warning-subtle text-warning-content">
        <ShieldAlert className="size-5" />
      </div>
      <h1 className="text-lg font-semibold text-foreground">You don't have access to {what}</h1>
      <p className="mt-1.5 text-sm text-muted-foreground">
        {/* A specific, role-free reason from the server (e.g. a switched-off module) beats the generic hint. */}
        {reason || 'If you need it for your work, ask your HR administrator to grant access.'}
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
        <Link to="/dashboard" className={buttonVariants({ variant: 'primary' })}>Go to dashboard</Link>
        <Link
          to={`/helpdesk?new=1&subject=${encodeURIComponent(`Access request: ${pathname}`)}`}
          className={buttonVariants({ variant: 'outline' })}
        >
          Request access
        </Link>
      </div>
    </div>
  )
}
